import { writable } from 'svelte/store'

export const periodStart = writable(0);
export const periodEnd = writable(0);
export const searchQuery = writable('');

export default {
    periodStart: periodStart,
    periodEnd: periodEnd,
    searchQuery: searchQuery
}